<template>
  <input-select ref="select" v-model="value" caption="Выберите маршрут..." :itemList="items"></input-select>
</template>

<script>
export default {
  props: ['model-value', 'park'],
  emits: ['update:model-value'],
  computed: {
    value: {
      get() {
        return this.modelValue
      },
      set(value) {
        this.$emit('update:model-value', value)
      }
    },
    items() {
      return this.$store.getters['getRoutes'].map(item => {
        return {
          id: item.routeId,
          title: item.routeName
        }
      });
    }
  },
  methods: {



    validate() {
      return this.$refs.select.validate()
    }
  }
}
</script>
